export const INACTIVE_INDEX_VALUE = -1;

export const animationTimeout = 500;
